import axios from "axios"
import { environment } from "../../environments/environment";

interface LoginData {
    username: string,
    password: string
};

interface LoginResponse {
    access: string
};

export interface TokenParams {
    token_type: string,
    exp: number,
    iat: number,
    jti: string,
    user_id: number,
    legacy_password_login: boolean,
    em_unit_id?: number,
    candidate_id?: string,
    manager_id?: string,
    company_id?: string,
    profiles: ('candidate' | 'job_manager' | 'em_job_manager')[]
}

interface OTPData {
    email: string
};

interface OTPConfirmationData {
    email: string,
    code: string
};

interface ChangePasswordData {
    new_password1: string,
    new_password2: string
};

export const login = async (data: LoginData) => {
    const response = await axios.post<LoginResponse>(environment.apiUrl+'/api/token/', data, {
        headers: {
            'Content-Type': 'application/json'
        }
    });

    if(response.status !== 200) {
        throw Error('error');
    };

    return response;
};

export const requestOTP = async (data: OTPData) => {
    const response = await axios.post<any>(environment.apiUrl+'/api/auth/request-code/', data, {
        headers: {
            'Content-Type': 'application/json'
        }
    });

    if(response.status !== 200) {
        throw Error('error');
    };

    return response;
};

export const validateOTP = async (data: OTPConfirmationData) => {
    const response = await axios.post<any>(environment.apiUrl+'/api/auth/validate-code/', data, {
        headers: {
            'Content-Type': 'application/json'
        }
    });

    if(response.status !== 200) {
        throw Error('error');
    };

    return response;
};

export const changePassword = async (data: ChangePasswordData) => {
    const response = await axios.post<any>(environment.apiUrl+'/api/auth/password/set/', data, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+localStorage.getItem('auth_token')
        }
    });

    if(response.status !== 200) {
        throw Error('error');
    };

    return response;
};